import type { AlertBeFrequency, EmailAlertType, IAlertEntityType, IQueryDataType } from '@patsnap/synapse_common_interface'
import { I18nLang } from '../i18n'
import { AlertFeFrequency } from '../types'

export const HistoryEmails = 'HistoryEmails'

/**
 * 邮件提醒实体名称的日文文案。
 * alertEntityConfig 来自公共配置包,仅提供 cn/en,这里单独补充日文
 */
export const alertEntityNameJpMap: Record<IAlertEntityType, string> = {
  drug: '医薬品',
  organization: '組織',
  target: '標的',
  target_extend: '標的',
  clinical_trial: '臨床試験',
  clinical_trial_result: '試験結果',
  patent: '特許',
  drug_type: 'モダリティ',
  disease: '適応症',
  translational_medicine: 'トランスレーショナルリサーチ',
  drug_deal: '提携',
}

/**
 * email alert frequency前端与后台的转换
 */
export const frequencyFE2BEConfig: Record<AlertFeFrequency, AlertBeFrequency> = {
  D: 'DAILY',
  W: 'WEEKLY',
  M: 'MONTHLY',
}

export const frequencyBE2FEConfig: Record<AlertBeFrequency, AlertFeFrequency> = {
  DAILY: 'D',
  WEEKLY: 'W',
  MONTHLY: 'M',
}

export const BindEmailConfig = {
  VERIFICATION_CODE_INTERVAL: 59,
  EMAIL_VERIFY_CODE_INTERVAL: 1000,
  VERIFICATION_EMAIL_CODE_INTERVAL: 59,
}

export const REVERSE_LANGUAGE_MAP: Record<I18nLang, string> = {
  cn: 'zh_CN',
  en: 'en_US',
  jp: 'ja_JP',
}

/**
 * alert转datatype，为了query转display的时候使用
 */
export const REVERSE_ALERT_TYPE_2_DATA_TYPE: Record<Exclude<EmailAlertType, 'ALL'>, IQueryDataType> = {
  DRUG_SEARCH: 'drug',
  DRUG_DETAIL: 'drug',
  TARGET: 'target',
  ORGANIZATION: 'organization',
}
